import React from "react";
import { FaEye } from "react-icons/fa";

function UserView({ visible, user, onClose }) {
  if (!visible || !user) return null;

  return (
    <div
      className="modal fade show"
      style={{
        display: "block",
        background: "rgba(0,0,0,0.2)",
        zIndex: 1050,
      }}
      tabIndex={-1}
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content p-3 rounded-4" style={{ minWidth: 470 }}>
          <div className="modal-header border-0 pb-0">
            <h4 className="modal-title fw-bold">
              <FaEye className="me-2" /> View User
            </h4> 
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              aria-label="Close"
            ></button>
          </div>
          <hr style={{ marginBottom: 0 }} />
          <div className="modal-body">
            {/* Basic Information */}
            <div className="mb-3">
              <div className="fw-bold mb-2" style={{ fontSize: 17 }}>Basic Information</div>
              <div className="text-muted" style={{ fontSize: 15 }}>
                User Id : {user.userId}<br />
                {user.name}<br />
                {user.roleAssigned}
                {user.note}
              </div>
            </div>
            <hr />
            {/* Quick Information */}
            <div className="mb-3">
              <div className="fw-bold mb-2" style={{ fontSize: 17 }}>Quick Information</div>
              <div className="row gx-3 gy-2">
                <div className="col-6">
                  <div style={{
                    background: "#eafaf1",
                    borderRadius: 12,
                    padding: "16px 12px",
                    minHeight: 70
                  }}>
                    <div className="small" style={{ color: "#34b67a", fontWeight: 500 }}>Status</div>
                    <div style={{ fontWeight: 600, fontSize: 19, color: "#34b67a" }}>
                      {user.status}
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div style={{
                    background: "#f1f3fc",
                    borderRadius: 12,
                    padding: "16px 12px",
                    minHeight: 70
                  }}>
                    <div className="small" style={{ color: "#5978e7", fontWeight: 500 }}>Role Assigned</div>
                    <div style={{ fontWeight: 600, fontSize: 19, color: "#5978e7" }}>
                      {user.role?.name}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Cancel Button */}
            <div className="d-flex justify-content-end mt-2">
              <button
                type="button"
                className="btn btn-light"
                style={{ minWidth: 110, borderRadius: 7 }}
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserView;